var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mx-auto",attrs:{"d-flex":"","max-width":"240"}},[_c('div',{staticClass:"chart-container",attrs:{"id":"chart-current-force"}}),_c('div',{staticClass:"chart-container",attrs:{"id":"chart-current-direction"}})])}
var staticRenderFns = []

export { render, staticRenderFns }